$(document).ready(function () {
  // Swiper and Slick load only on pages that use them (layout/theme.liquid).
  if (window.Swiper) {
    new Swiper('.swiper', {
      freeMode: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      slidesPerView: 2,
      spaceBetween: 16,
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 64,
        },
      },
    });
  }

  $('#menu-trigger').click(function () {
    if ($(this).hasClass('open')) {
      $('#menu').removeClass('!translate-x-0');
      $(this).text('Menu').removeClass('open');
    } else {
      $('#menu').addClass('!translate-x-0');
      $(this).text('Close').addClass('open');
    }
  });

  function closeCartDrawer() {
    $('#cart-drawer').addClass('translate-x-full');
    $('#cart-drawer-trigger').text('Cart').removeClass('open');
  }

  $('#cart-drawer-trigger').click(function () {
    if ($(this).hasClass('open')) {
      closeCartDrawer();
    } else {
      $('#cart-drawer').removeClass('translate-x-full');
      $(this).text('Close').addClass('open');
    }
  });

  // A click outside the open cart drawer closes it. composedPath() still holds drawer elements that a click handler
  // removed (a deleted line item), so those don't count as outside. Only a person's click counts: product-tabs.js
  // clicks the "Full description" header as a product page loads, which would shut the drawer cart-edit.js has just
  // opened after an add.
  $(document).on('click', function (event) {
    if (!event.originalEvent || !event.originalEvent.isTrusted || !$('#cart-drawer-trigger').hasClass('open')) return;
    const path = event.originalEvent.composedPath();
    if (path.includes(document.getElementById('cart-drawer'))) return;
    if (path.includes(document.getElementById('cart-drawer-trigger'))) return;
    closeCartDrawer();
  });

  $(document).on('keydown', function (event) {
    if (event.key == 'Escape') {
      $('#menu').removeClass('!translate-x-0');
      $('#menu-trigger').text('Menu').removeClass('open');
      // Escape closes the cart drawer too, so a keyboard user isn't kept in it, and returns focus to the Cart button.
      if ($('#cart-drawer-trigger').hasClass('open')) {
        closeCartDrawer();
        $('#cart-drawer-trigger').trigger('focus');
      }
    }
  });

  $('.accordion-header').click(function (e) {
    parent = $(this).parent('.accordion');
    content = $(this).siblings('.accordion-content');
    expandMore = $(this).find('.expand-more');
    expandLess = $(this).find('.expand-less');
    if (parent.hasClass('active')) {
      content.addClass('h-0');
      parent.removeClass('active');
      expandLess.hide();
      expandMore.show();
      return;
    }
    if (parent.hasClass('single-accordion')) {
      $('.accordion-content').addClass('h-0');
      $('.accordion').removeClass('active');
      $('.expand-more').show();
      $('.expand-less').hide();
    }
    content.removeClass('h-0');
    parent.addClass('active');
    expandMore.hide();
    expandLess.show();
  });

  if ($.fn.slick) {
    $('#product-slider').slick({
      fade: true,
      cssEase: 'linear',
      arrows: true,
      prevArrow: '#product-slider-prev',
      nextArrow: '#product-slider-next',
      dots: true,
      appendDots: $('#product-slider-dots'),
    });

    $('.home-slider').slick({
      centerMode: true,
      centerPadding: 0,
      slidesToShow: 1,
      infinite: false,
      arrows: false,
      dots: true,
      appendDots: $('.home-slider-dots'),
    });
  }

  // Cache DOM queries
  const homeAside = document.querySelector('aside.home-textures');
  const navAsides = document.querySelectorAll('aside.nav-textures');
  const productAsides = document.querySelectorAll('aside.product-textures');

  const texturesLists = document.querySelectorAll('[data-background_textures]');
  const sizeClassesList = document.querySelector('[data-background_textures_sizes]');
  const sizeClassesItems = sizeClassesList.querySelectorAll('li');

  // Function to generate a random number within a range
  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // Function to shuffle an array in place
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  // Precompute random size classes array
  /* const sizeClasses = [
    'w-[2.5%]',
    'w-[5%]',
    'w-[7.5%]',
    'w-[10%]',
    'w-[12.5%]',
    'w-[15%]',
    'w-[17.5%]',
    'w-[20%]',
    'w-[22.5%]',
    'w-[25%]',
    'w-[27.5%]',
    'w-[30%]',
  ]; */
  const sizeClasses = [];
  sizeClassesItems.forEach((sizeItem) => sizeClasses.push(sizeItem.className));
  sizeClassesList.parentElement.removeChild(sizeClassesList);

  const backgroundTextures = {};
  texturesLists.forEach((list) => {
    const textures = [];
    const items = list.querySelectorAll('[data-src]');
    items.forEach((item) => textures.push(item.dataset.src));
    backgroundTextures[list.dataset.background_textures] = textures;
  });
  texturesLists.forEach((list) => list.parentElement.removeChild(list));

  // Function to get a random size class
  function getRandomSizeClass() {
    return sizeClasses[Math.floor(Math.random() * sizeClasses.length)];
  }

  // Function to set random background textures
  function setBackgroundTextures() {
    const blueTextures = Array.from({ length: 8 }, (_, i) => `images/blue-textures/${i + 1}.jpg`);
    const greenTextures = Array.from({ length: 15 }, (_, i) => `images/green-textures/${i + 1}.jpg`);
    const yellowTextures = Array.from({ length: 15 }, (_, i) => `images/yellow-textures/${i + 1}.jpg`);

    const homeNumTextures = 40;
    let homeTextures = [...backgroundTextures.blue, ...backgroundTextures.green, ...backgroundTextures.yellow];
    shuffleArray(homeTextures);

    // Set home textures if homeAside is present
    if (homeAside) {
      setTextures(homeAside, homeTextures, homeNumTextures);
    }

    const navNumTextures = 15;
    let navTextures = [...backgroundTextures.yellow];
    shuffleArray(navTextures);

    // Set nav textures for each navAside if present
    navAsides.forEach((navAside) => {
      if (navAside) {
        setTextures(navAside, navTextures, navNumTextures);
      }
    });

    const productNumTextures = 10;
    let productTextures = [...backgroundTextures.green];
    shuffleArray(productTextures);

    // Set nav textures for each productAside if present
    productAsides.forEach((productAside) => {
      if (productAside) {
        setTextures(productAside, productTextures, productNumTextures);
      }
    });
  }

  // Function to set textures for a given aside element
  function setTextures(asideElement, textures, numTextures) {
    asideElement.innerHTML = ''; // Clear previous images
    textures.slice(0, numTextures).forEach((texture) => {
      const img = new Image();
      // Lazy, and src set after insertion: textures in hidden containers (the desktop-only menu) never download.
      img.loading = 'lazy';
      img.decoding = 'async';
      img.classList.add(
        'texture',
        'mix-blend-multiply',
        'pointer-events-none',
        'absolute',
        'max-w-md',
        'min-w-[8rem]',
        getRandomSizeClass()
      );

      const isLeft = Math.random() < 0.5;
      const isTop = Math.random() < 0.5;
      const positionValue = getRandomNumber(-10, 110);
      img.style[isLeft ? 'left' : 'right'] = `${positionValue}%`;
      img.style[isTop ? 'top' : 'bottom'] = `${positionValue}%`;

      asideElement.appendChild(img);
      img.src = texture;
    });
  }

  window.onload = setBackgroundTextures;
});
